var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_vm._v(_vm._s(_vm.params.data.target)+" "+_vm._s(_vm.params.data.target_currency))]),_c('div',{staticClass:"target-type"},[_vm._v(_vm._s(_vm.params.data.target_type.toUpperCase())+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }